$(document).ready(function(){
    //open external links in new tab
    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
	// video popup 1
	$("#index-top-image button.video-launch").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup").show();
		console.lg('gsgsg');
	});
	$(".freshwater-video-popup-close").click(function () {
		$(".freshwater-video-popup-background, .freshwater-video-popup").hide();
		$(".freshwater-video-popup iframe").each(function(index) {
	        $(this).attr('src', $(this).attr('src'));
	        return false;
	      });
	});

	//hide grid section if no grid items
	if ($(".block-image-section").length) {
		
	} else {
		$("#fresh-main .block-image-section-wrapper").hide();
	}

	//submenu
	$(".freshwater-products-menu span.freshwater-products-menu-header, .freshwater-products-menu-header-open").click(function() {
			$(".freshwater-products-menu ul").slideToggle();
			$(".freshwater-products-menu-header-open").toggleClass("rotate-45");
	});

	//mobile footer
	$("h3.footer-menu-header").click(function() {
		$(this).next().slideToggle();
		$(this).find("span").toggleClass("rotate-45");
		
	});

});

